import { adminWhatsappNumero } from '@/mocks/admin';

interface QuoteVariant {
  tipo?: string;
  cor: string;
  tamanho: string;
  sku: string;
  estoque?: number;
}

interface ProductQuotePayload {
  productName: string;
  productSku?: string;
  brand?: string;
  quantity: number;
  variant?: QuoteVariant;
  atasNomes?: string[];
}

export function openProductQuoteOnWhatsApp({
  productName,
  productSku,
  brand,
  quantity,
  variant,
  atasNomes = [],
}: ProductQuotePayload) {
  const variantLabel = variant
    ? [variant.tipo ? `${variant.tipo}:` : '', variant.cor, variant.tamanho].filter(Boolean).join(' ')
    : '';

  const lines = [
    'Olá, gostaria de consultar um orçamento.',
    '',
    `Produto: ${productName}`,
    brand ? `Marca: ${brand}` : '',
    productSku ? `SKU: ${productSku}` : '',
    variant ? `Variante: ${variantLabel} (${variant.sku})` : '',
    `Quantidade: ${quantity}`,
    atasNomes.length > 0 ? `Atas vinculadas: ${atasNomes.join(', ')}` : '',
  ].filter(Boolean);

  window.open(
    `https://wa.me/${adminWhatsappNumero}?text=${encodeURIComponent(lines.join('\n'))}`,
    '_blank',
    'noopener,noreferrer',
  );
}
